export default {"src":"/_next/static/media/Crop-Stumps_Willow.9db73fd9.svg","height":337,"width":272,"blurWidth":0,"blurHeight":0};